(ns yardwerkz.web.booking.address
  "Step 2: Address entry with Mapbox geocoding autocomplete."
  (:require
   [uix.core :refer [defui $ use-state use-effect use-callback]]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [yardwerkz.web.mapbox :as mapbox]
   [yardwerkz.web.ui.components :as ui]
   [yardwerkz.web.ui.icons :as icons]))

(defui address-step [{:keys [on-next]}]
  (let [dispatch (rfx/use-dispatch)
        saved-address (rfx/use-sub [::store/draft-address])
        [query set-query] (use-state (or (:address saved-address) ""))
        [results set-results] (use-state nil)
        [searching set-searching] (use-state false)
        [selected set-selected] (use-state saved-address)

        do-search (use-callback
                   (fn [q]
                     (when (>= (count q) 3)
                       (set-searching true)
                       (-> (mapbox/search-address q :country "us" :limit 5)
                           (.then (fn [res]
                                    (set-searching false)
                                    (when (:ok res)
                                      (set-results (:results res)))))
                           (.catch (fn [_]
                                     (set-searching false))))))
                   [])]

    ;; Debounced search
    (use-effect
     (fn []
       (when (and (>= (count query) 3) (not selected))
         (let [timer (js/setTimeout #(do-search query) 300)]
           (fn [] (js/clearTimeout timer))))
       js/undefined)
     [query selected do-search])

    ($ :div
       ($ :h2 {:class "text-lg font-semibold text-gray-900 mb-4"} "Where is the property?")

       ;; Search input
       ($ :div {:class "relative"}
          ($ :div {:class "absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"}
             ($ icons/MapPin {:size 18}))
          ($ :input {:class "w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                     :value query
                     :on-change (fn [e]
                                  (let [v (.. e -target -value)]
                                    (set-query v)
                                    (when selected
                                      (set-selected nil)
                                      (set-results nil))))
                     :placeholder "Enter address..."}))

       ;; Results dropdown
       (when (and (seq results) (not selected))
         ($ :div {:class "mt-2 border border-gray-200 rounded-xl bg-white shadow-lg overflow-hidden"}
            (for [result results]
              ($ :button {:key (:id result)
                          :class "w-full px-4 py-3 text-left hover:bg-gray-50 border-b border-gray-100 last:border-0"
                          :on-click (fn []
                                      (set-selected result)
                                      (set-query (or (:full-address result) (:address result)))
                                      (set-results nil)
                                      (dispatch [::store/set-address result]))}
                 ($ :p {:class "text-sm font-medium text-gray-900"}
                    (or (:address result) ""))
                 ($ :p {:class "text-xs text-gray-500"}
                    (str (:city result) ", " (:state result) " " (:postal-code result)))))))

       ;; Loading
       (when searching
         ($ :div {:class "mt-2 flex items-center space-x-2 text-sm text-gray-500"}
            ($ ui/spinner {:size :sm})
            ($ :span "Searching...")))

       ;; Selected address confirmation
       (when selected
         ($ :div {:class "mt-4 p-4 bg-green-50 border border-green-200 rounded-xl flex items-start space-x-3"}
            ($ icons/CheckCircle {:size 20 :class "text-green-600 mt-0.5"})
            ($ :div
               ($ :p {:class "text-sm font-medium text-green-900"}
                  (or (:full-address selected) (:address selected)))
               ($ :p {:class "text-xs text-green-700 mt-0.5"}
                  (str (:city selected) ", " (:state selected) " " (:postal-code selected)))
               ($ :button {:class "mt-2 text-xs text-green-600 hover:text-green-800 underline"
                           :on-click (fn []
                                       (set-selected nil)
                                       (set-query "")
                                       (set-results nil))}
                  "Change address")))))))
